import React, { useEffect, useRef, useState } from 'react';

/**
 * Renders a chart/panel title.
 * If `onSave` is provided (admin only), clicking the title makes it editable inline.
 * Pressing Enter or blurring commits the change.
 */
export default function EditableTitle({ value, onSave, className = '' }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft]     = useState(value);
  const inputRef = useRef(null);

  // Keep draft in sync when external value changes (e.g. project switch)
  useEffect(() => { setDraft(value); }, [value]);

  useEffect(() => {
    if (editing) inputRef.current?.select();
  }, [editing]);

  const commit = () => {
    setEditing(false);
    const trimmed = draft.trim();
    if (trimmed && trimmed !== value) onSave(trimmed);
    else setDraft(value); // revert if empty or unchanged
  };

  const handleKey = (e) => {
    if (e.key === 'Enter')  { e.preventDefault(); commit(); }
    if (e.key === 'Escape') { setEditing(false); setDraft(value); }
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        className={`editable-title-input ${className}`}
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={handleKey}
      />
    );
  }

  return (
    <span
      className={`editable-title ${onSave ? 'editable-title--admin' : ''} ${className}`}
      onClick={() => onSave && setEditing(true)}
      title={onSave ? 'Click to rename' : undefined}
    >
      {value}
      {onSave && <span className="editable-title-icon">✏️</span>}
    </span>
  );
}
